import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";

import { TemplateButtons, TemplateFooter, TemplateSubMessage, TemplateTexts } from "../TemplatePartials";
import TemplateMessageUtils from "../../../utils/classes/TemplateMessageUtils";

const useStyles = makeStyles(theme => ({
  templateMainContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "1em",
  },

  templateTextsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "7px",
  }
}));

const TemplateCustomMinified = ({ message, messageDataJson, templateType, shouldDisplayCompleteTemplate }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  const [templateData, setTemplateData] = useState(TemplateMessageUtils.DEFAULT_TEMPLATE_DATA);



  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    setTemplateData(TemplateMessageUtils.getTemplateData(message, messageDataJson, templateType));
  }, [message, messageDataJson, templateType]);



  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={classes.templateMainContainer}>
      {shouldDisplayCompleteTemplate && messageDataJson && (templateData.subMessage.mediaUrl || templateData.subMessage.body) && (
        <div className={classes.templateSubMessageContainer}>
          <TemplateSubMessage
            type={templateData.subMessage.type}
            mediaUrl={templateData.subMessage.mediaUrl}
            body={templateData.subMessage.body}
            isDeleted={message.isDeleted}
          />
        </div>
      )}

      {(templateData.title || templateData.body) && (
        <div className={classes.templateTextsContainer}>
          <TemplateTexts title={templateData.title} body={templateData.body} />
        </div>
      )}

      {shouldDisplayCompleteTemplate && templateData.buttons && templateData.buttons.length > 0 && (
        <div className={classes.templateButtonsContainer}>
          <TemplateButtons
            buttons={templateData.buttons}
            message={message}
            ticketId={null}
            isMinifiedPreview={true}
          />
        </div>
      )}

      {shouldDisplayCompleteTemplate && templateData.footer && (
        <div className={classes.templateTextsContainer}>
          <TemplateFooter footer={templateData.footer} />
        </div>
      )}
    </div>
  );
};

export default TemplateCustomMinified;
